<template>
    <b-container fluid>
        <b-row>
            <b-col class="py-2" cols="12" md="4" lg="4">
                <app-form-input
                    label="Nombre completo"
                    :has-error="$v.userInfo.fullName.$error"
                    @input="$v.userInfo.fullName.$touch()"
                    v-model="userInfo.fullName"
                    :required="true"
                ></app-form-input>
            </b-col>
            <b-col class="py-2" cols="12" md="4" lg="4">
                <app-form-input
                    label="Documento"
                    :has-error="$v.userInfo.document.$error"
                    @input="$v.userInfo.document.$touch()"
                    v-model="userInfo.document"
                    :required="true"
                ></app-form-input>
            </b-col>
            <b-col class="py-2" cols="12" md="4" lg="4">
                <app-form-date
                    label="Fecha de Nacimiento"
                    :has-error="$v.userInfo.birthDate.$error"
                    @input="$v.userInfo.birthDate.$touch()"
                    v-model="userInfo.birthDate"
                    @change="updateAge"
                    :required="true"
                ></app-form-date>
            </b-col>
            <b-col class="py-2" cols="12" md="4" lg="4">
                <app-form-input
                    type="number"
                    label="Edad"
                    :has-error="$v.userInfo.age.$error"
                    @input="$v.userInfo.age.$touch()"
                    v-model="userInfo.age"
                    :disabled="true"
                ></app-form-input>
            </b-col>
            <b-col class="py-2" cols="12" md="4" lg="4">
                <app-form-select
                    label="Libreta Militar"
                    :options="militarCardOptions"
                    @change="
                        (userInfo.militarCardClass = '') &&
                            $v.userInfo.militarCard.$touch()
                    "
                    :has-error="$v.userInfo.militarCard.$error"
                    v-model="userInfo.militarCard"
                    :required="true"
                ></app-form-select>
            </b-col>
            <b-col class="py-2" cols="12" md="4" lg="4">
                <app-form-select
                    label="Clase"
                    :options="militarCardClassOptions"
                    @change="$v.userInfo.militarCardClass.$touch()"
                    :has-error="$v.userInfo.militarCardClass.$error"
                    v-model="userInfo.militarCardClass"
                    :disabled="userInfo.militarCard !== 'SI'"
                    :required="true"
                ></app-form-select>
            </b-col>
            <b-col class="py-2" cols="12" md="4" lg="4">
                <app-form-input
                    type="number"
                    label="Teléfono 1"
                    v-model="userInfo.phone1"
                ></app-form-input>
            </b-col>
            <b-col class="py-2" cols="12" md="4" lg="4">
                <app-form-input
                    type="number"
                    label="Teléfono 2"
                    v-model="userInfo.phone2"
                ></app-form-input>
            </b-col>
            <b-col class="py-2" cols="12" md="4" lg="4">
                <app-form-input
                    type="number"
                    label="Celular"
                    :has-error="$v.userInfo.mobile.$error"
                    @input="$v.userInfo.mobile.$touch()"
                    v-model="userInfo.mobile"
                    :required="true"
                ></app-form-input>
            </b-col>
            <b-col class="py-2" cols="12" md="4" lg="6">
                <app-form-input
                    type="email"
                    label="E-mail"
                    :has-error="$v.userInfo.email.$error"
                    @input="$v.userInfo.email.$touch()"
                    v-model="userInfo.email"
                    :required="true"
                ></app-form-input>
            </b-col>
            <b-col class="py-2" cols="12" md="4" lg="6">
                <app-form-input
                    label="Dirección"
                    :has-error="$v.userInfo.address.$error"
                    @input="$v.userInfo.address.$touch()"
                    v-model="userInfo.address"
                    :required="true"
                ></app-form-input>
            </b-col>
            <b-col class="py-2" cols="12" md="4" lg="4">
                <app-form-input
                    label="Barrio"
                    :has-error="$v.userInfo.neighborhood.$error"
                    @input="$v.userInfo.neighborhood.$touch()"
                    v-model="userInfo.neighborhood"
                    :required="true"
                ></app-form-input>
            </b-col>
            <b-col class="py-2" cols="12" md="4" lg="4">
                <app-form-select
                    type="number"
                    label="Estrato"
                    :options="socialLevelOptions"
                    :has-error="$v.userInfo.socialLevel.$error"
                    @input="$v.userInfo.socialLevel.$touch()"
                    v-model="userInfo.socialLevel"
                    :required="true"
                ></app-form-select>
            </b-col>
            <b-col class="py-2" cols="12" md="4" lg="4">
                <app-form-select
                    label="Estado Civíl"
                    :options="maritalStatusOptions"
                    :has-error="$v.userInfo.maritalStatus.$error"
                    @input="$v.userInfo.maritalStatus.$touch()"
                    @change="onMaritalStatusChange"
                    v-model="userInfo.maritalStatus"
                    :required="true"
                ></app-form-select>
            </b-col>
            <b-col class="py-2" cols="12" md="4" lg="4">
                <app-form-input
                    label="Tiempo de Convivencia"
                    :has-error="$v.userInfo.relationshipTime.$error"
                    @input="$v.userInfo.relationshipTime.$touch()"
                    v-model="userInfo.relationshipTime"
                    :disabled="relationshipTimeDisable"
                ></app-form-input>
            </b-col>
            <b-col class="py-2" cols="12" md="4" lg="4">
                <app-form-select
                    label="Tipo de Vivienda"
                    :options="housingTypeOptions"
                    :has-error="$v.userInfo.housingType.$error"
                    @change="$v.userInfo.housingType.$touch()"
                    v-model="userInfo.housingType"
                    :required="true"
                ></app-form-select>
            </b-col>
            <b-col class="py-2" cols="12" md="4" lg="4">
                <app-form-select
                    label="Nivel de estudios"
                    :options="scholarshipLevelOptions"
                    :has-error="$v.userInfo.greatestEducationLevel.$error"
                    @change="$v.userInfo.greatestEducationLevel.$touch()"
                    v-model="userInfo.greatestEducationLevel"
                    :required="true"
                ></app-form-select>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
import {
    required,
    email,
    numeric,
    requiredIf,
    maxLength,
    minLength
} from "vuelidate/lib/validators";
import usersRepository from "../../../../repositories/users.repository";
export default {
    data: () => ({
        userInfo: {
            fullName: "",
            document: "",
            age: "",
            birthDate: "",
            militarCard: "",
            militarCardClass: "",
            phone1: "",
            phone2: "",
            mobile: "",
            email: "",
            address: "",
            neighborhood: "",
            socialLevel: "",
            maritalStatus: "",
            relationshipTime: "",
            housingType: "",
            greatestEducationLevel: ""
        },
        militarCardOptions,
        militarCardClassOptions,
        housingTypeOptions,
        maritalStatusOptions,
        scholarshipLevelOptions,
        socialLevelOptions
    }),
    validations: {
        userInfo: {
            fullName: { required },
            document: { required },
            age: { required },
            birthDate: { required },
            militarCard: { required },
            militarCardClass: {
                requiredIf: requiredIf("militarCardClassRequired")
            },
            mobile: { required, numeric },
            email: {
                required,
                email,
                maxLength: maxLength(10),
                minLength: minLength(10)
            },
            address: { required },
            neighborhood: { required },
            socialLevel: { required, numeric },
            maritalStatus: { required },
            relationshipTime: { required },
            housingType: { required },
            greatestEducationLevel: { required }
        }
    },
    computed: {
        militarCardClassRequired() {
            return this.userInfo.militarCard === "SI";
        },
        relationshipTimeDisable() {
            return ["Soltero", "Viudo"].includes(this.userInfo.maritalStatus);
        }
    },
    methods: {
        updateAge() {
            const age = moment().diff(moment(this.userInfo.birthDate), "years");
            this.userInfo.age = age;
        },
        async saveInfo() {
            this.$v.$touch();
            if (this.$v.$invalid) return;

            const ur = { ...usersRepository };

            try {
                const { data } = await ur.saveUserInfo(
                    this.user.id,
                    this.userInfo
                );
                if (data.status) {
                    this.$emit("saved", data);
                } else {
                    toastr.error(data.msg);
                }
            } catch (err) {
                this.handleErrors(err);
            } finally {
            }
        },
        onMaritalStatusChange(val) {
            if (["Soltero", "Viudo"].includes(val)) {
                this.userInfo.relationshipTime = 0;
            } else {
                this.userInfo.relationshipTime = "";
            }
        }
    },
    mounted() {
        this.$bus.$on("userInfoForm.save", this.saveInfo);
    },
    beforeDestroy() {
        this.$bus.$off("userInfoForm.save");
    }
};

const scholarshipLevelOptions = [
    {
        value: "Ninguno",
        text: "Ninguno"
    },
    {
        value: "Primaria",
        text: "Primaria"
    },
    {
        value: "Bachiller",
        text: "Bachiller"
    },
    {
        value: "Tecnólogo",
        text: "Tecnólogo"
    },
    {
        value: "Técnico",
        text: "Técnico"
    },
    {
        value: "Profesional",
        text: "Profesional"
    }
];

const militarCardOptions = [
    {
        value: null,
        text: "Seleccione"
    },
    {
        value: "SI",
        text: "SI"
    },
    {
        value: "NO",
        text: "NO"
    }
];
const militarCardClassOptions = [
    {
        value: null,
        text: "Seleccione"
    },
    {
        value: 1,
        text: "1"
    },
    {
        value: 2,
        text: "2"
    }
];
const housingTypeOptions = [
    {
        value: "Propia",
        text: "Propia"
    },
    {
        value: "Familiar",
        text: "Familiar"
    },
    {
        value: "Alquilada",
        text: "Alquilada"
    }
];
const maritalStatusOptions = [
    {
        value: "Soltero",
        text: "Solter@"
    },
    {
        value: "Casado",
        text: "Casad@"
    },
    {
        value: "Union libre",
        text: "Union libre"
    },
    {
        value: "Viudo",
        text: "Viud@"
    }
];
const socialLevelOptions = [
    {
        value: 1,
        text: "1"
    },
    {
        value: 2,
        text: "2"
    },
    {
        value: 3,
        text: "3"
    },
    {
        value: 4,
        text: "4"
    },
    {
        value: 5,
        text: "5"
    },
    {
        value: 6,
        text: "6"
    }
];
</script>
